<template>
  <b-container v-if="user" fluid class="mt-2 px-1 px-sm-3 pb-2">
    <b-row>
      <b-col cols="" class="">
        <b-row>
          <b-col cols="">
            <div
              class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-0"
            >
              <h2 class="text-left">{{ $t("dashboardPage.title") }}</h2>
            </div>
          </b-col>
        </b-row>
        <b-row class="dashboard_total" v-if="summaryLoading">
          <b-col
            v-for="(c, i) in summaryCardClasses"
            :key="`summary-skeleton-${i}`"
            :xl="c.xl"
            lg="4"
            md="6"
            :class="c.class"
          >
            <div class="total_team">
              <b-skeleton type="avatar"></b-skeleton>
              <div class="flex-grow-1 ml-3">
                <b-skeleton width="45%" height="22px"></b-skeleton>
                <b-skeleton width="75%"></b-skeleton>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row
          class="dashboard_total"
          v-else-if="
            $store.state.user &&
            $store.state.user.user &&
            $store.state.user.user.team_member &&
            $store.state.user.user.team_member.role !== 'Owner Operator'
          "
        >
          <b-col xl="3" lg="4" md="6" class="px-3 pr-lg-0 mt-3">
            <div class="total_team total_driver total_team--top">
              <b-img :src="require('@/assets/total_drivers.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.total_drivers || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.totalDrivers") }}</p>
                <p class="assignment-split">
                  {{
                    $t("dashboardPage.driverSplit", {
                      active: dashboardSummary.active_drivers || 0,
                      inactive: dashboardSummary.inactive_drivers || 0,
                    })
                  }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 mt-3 pr-xl-3 pr-lg-0">
            <div class="total_team total_vehicle total_team--top">
              <b-img :src="require('@/assets/total_vehicles.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.total_vehicles || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.totalVehicles") }}</p>
                <p class="assignment-split">
                  {{
                    $t("dashboardPage.assignmentSplit", {
                      assigned: dashboardSummary.assigned_vehicles || 0,
                      unassigned: dashboardSummary.unassigned_vehicles || 0,
                    })
                  }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 px-xl-0 mt-3">
            <div class="total_team total_trailer total_team--top">
              <b-img :src="require('@/assets/total_trailers.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.total_trailers || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.totalTrailers") }}</p>
                <p class="assignment-split">
                  {{
                    $t("dashboardPage.assignmentSplit", {
                      assigned: dashboardSummary.assigned_trailers || 0,
                      unassigned: dashboardSummary.unassigned_trailers || 0,
                    })
                  }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 pr-xl-3 pr-lg-0 mt-3">
            <div class="total_team total_team--top">
              <b-img :src="require('@/assets/total-docs.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.total_documents || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.totalDocuments") }}</p>
                <p class="assignment-split">
                  {{
                    $t("dashboardPage.documentSplit", {
                      unarchived: dashboardSummary.unarchived_documents || 0,
                      archived: dashboardSummary.archived_documents || 0,
                    })
                  }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 pr-lg-0 mt-3">
            <div class="total_team total_driver justify-content-between">
              <div class="d-flex align-items-center">
                <b-img :src="require('@/assets/expired-docs.svg')"></b-img>
                <div>
                  <div class="d-flex align-items-center">
                    <h5 class="number">
                      {{ dashboardSummary.expired_documents_count || 0 }}
                    </h5>
                    <p class="mb-0 ml-2 f-14 font-weight-bold">
                      ({{
                        parseFloat(dashboardSummary.expired_documents_percentage).toFixed(
                          1
                        ) || 0
                      }}%)
                    </p>
                  </div>
                  <p>{{ $t("dashboardPage.expired") }}</p>
                </div>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 mt-3">
            <div class="total_team total_vehicle justify-content-between">
              <div class="d-flex align-items-center">
                <b-img :src="require('@/assets/expiring-soon.svg')"></b-img>
                <div>
                  <div class="d-flex align-items-center">
                    <h5 class="number">
                      {{ dashboardSummary.expiring_soon_count || 0 }}
                    </h5>
                    <p class="mb-0 ml-2 f-14 font-weight-bold">
                      ({{
                        parseFloat(
                          dashboardSummary.expiring_soon_documents_percentage
                        ).toFixed(1) || 0
                      }}%)
                    </p>
                  </div>
                  <p>{{ $t("dashboardPage.expiringSoon") }}</p>
                </div>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 px-xl-0 pr-lg-0 mt-3">
            <div class="total_team total_vehicle">
              <b-img :src="require('@/assets/review.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.review_count || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.review") }}</p>
              </div>
            </div>
          </b-col>
          <b-col xl="3" lg="4" md="6" class="px-3 pr-xl-3 pr-lg-0 mt-3">
            <div class="total_team">
              <b-img :src="require('@/assets/total-file-drop.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.file_drop_count || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.fileDrop") }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="dashboard_total" v-else>
          <b-col xl="4" lg="4" md="6" class="px-3 pr-lg-0 mt-3">
            <div class="total_team">
              <b-img :src="require('@/assets/total-docs.svg')"></b-img>
              <div>
                <h5 class="number">
                  {{ dashboardSummary.total_documents || 0 }}
                </h5>
                <p>{{ $t("dashboardPage.totalDocuments") }}</p>
              </div>
            </div>
          </b-col>
          <b-col xl="4" lg="4" md="6" class="px-3 mt-3">
            <div class="total_team total_driver justify-content-between">
              <div class="d-flex align-items-center">
                <b-img :src="require('@/assets/expired-docs.svg')"></b-img>
                <div>
                  <h5 class="number">
                    {{ dashboardSummary.expired_documents_count || 0 }}
                  </h5>
                  <p>{{ $t("dashboardPage.expired") }}</p>
                </div>
              </div>
              <p class="mb-0 text-danger-color f-16 font-weight-bold">
                {{
                  parseFloat(dashboardSummary.expired_documents_percentage).toFixed(1) ||
                  0
                }}%
              </p>
            </div>
          </b-col>
          <b-col xl="4" lg="4" md="6" class="px-3 mt-3 pl-lg-0">
            <div class="total_team total_vehicle justify-content-between">
              <div class="d-flex align-items-center">
                <b-img :src="require('@/assets/expiring-soon.svg')"></b-img>
                <div>
                  <h5 class="number">
                    {{ dashboardSummary.expiring_soon_count || 0 }}
                  </h5>
                  <p>{{ $t("dashboardPage.expiringSoon") }}</p>
                </div>
              </div>
              <p class="mb-0 text-warning-color f-16 font-weight-bold">
                {{
                  parseFloat(dashboardSummary.expiring_soon_documents_percentage).toFixed(
                    1
                  ) || 0
                }}%
              </p>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="12" md="12" sm="12" cols="12" class="my-1">
            <div class="data-table team-data-table table-custom-border">
              <div class="bg-white rounded">
                <v-tabs
                  class="team-tabs mb-0"
                  v-if="isTableMounted && !allowUpdateOwnerOperatorDocs"
                  show-arrows
                >
                  <v-tab @click="setDocumentType('')"
                    >{{ $t("dashboardPage.tabActive") }}
                    <span class="f-12 ml-1">
                      ({{ regularCount ? regularCount : 0 }})</span
                    ></v-tab
                  >
                  <v-tab @click="setDocumentType('snoozed')"
                    >{{ $t("dashboardPage.tabSnoozed") }}
                    <span class="f-12 ml-1">
                      ({{ snoozedCount ? snoozedCount : 0 }})</span
                    ></v-tab
                  >
                  <v-tab class="with-border" @click="setDocumentType('no_notify')"
                    >{{ $t("dashboardPage.tabInactive")
                    }}<span class="f-12 ml-1">
                      ({{ noNotifyCount ? noNotifyCount : 0 }})</span
                    ></v-tab
                  >
                  <v-tab class="with-border" @click="setDocumentType('required_docs')"
                    >{{ $t("dashboardPage.tabMissingDocs")
                    }}<span class="f-12 ml-1">
                      ({{ requiredDocsCount ? requiredDocsCount : 0 }})</span
                    ></v-tab
                  >
                  <v-tab @click="setDocumentType('live_view')"
                    >{{ $t("dashboardPage.tabLiveView")
                    }}<span class="f-12 ml-1">
                      ({{ liveViewCount ? liveViewCount : 0 }})</span
                    ></v-tab
                  >
                </v-tabs>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded">
                <div class="table_row">
                  <div class="equipment-border filter-box table_row">
                    <div class="d-flex px-3 px-sm-4 mb-3 mb-sm-4">
                      <b-form-group
                        class="text-left label font-weight-normal search-field mb-0"
                      >
                        <b-input-group class="username-input-field">
                          <b-form-input
                            type="text"
                            :placeholder="$t('dashboardPage.search')"
                            v-model="filterFields.search"
                            class="unit f-12"
                            @keyup.enter="getDocuments()"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button variant="primary" @click="getDocuments()">
                              <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 10.5L13 13.5"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <div
                        class="ml-auto d-none d-sm-flex align-items-center flex-wrap"
                        v-if="!allowUpdateOwnerOperatorDocs"
                      >
                        <div class="position-relative">
                          <div
                            class="position-absolute notification-badge"
                            v-if="activeFiltersCount"
                          >
                            {{ activeFiltersCount }}
                          </div>
                          <button
                            class="btn btn-filter-section"
                            @click="$bvModal.show('modal-filter')"
                          >
                            <div class="d-flex align-items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-sliders-horizontal w-4 h-4"
                                data-id="element-964"
                              >
                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                <line x1="16" x2="16" y1="18" y2="22"></line>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t("dashboardPage.filters") }}</p>
                            </div>
                          </button>
                        </div>
                        <b-button
                          v-if="
                            allowViewDocCompany ||
                            allowViewDocDrivers ||
                            allowViewDocEquipment
                          "
                          @click="downloadExcel"
                          class="ml-2"
                          variant="dashboard-export-table-btn"
                        >
                          <div class="d-flex align-items-center">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.0206 6.20996H10.364V7.80592H13.0206C13.8106 7.80592 14.4235 8.21448 14.4235 8.56613V15.6431C14.4235 15.9948 13.8106 16.4033 13.0206 16.4033H2.97916C2.18919 16.4033 1.57628 15.9948 1.57628 15.6431V8.56639C1.57628 8.21475 2.18919 7.80618 2.97916 7.80618H5.63519V6.21023H2.97916C1.30857 6.21023 0 7.24521 0 8.56639V15.6434C0 16.9648 1.30857 17.9996 2.97916 17.9996H13.0208C14.6912 17.9996 16 16.9646 16 15.6434V8.56639C15.9997 7.24494 14.6912 6.20996 13.0206 6.20996Z"
                                fill="#212529"
                              />
                              <path
                                d="M5.66755 3.97792C5.86932 3.97792 6.07082 3.89999 6.22477 3.74411L7.21151 2.74505V6.2104V7.80636V10.8637C7.21151 11.3044 7.56434 11.6617 7.99965 11.6617C8.43497 11.6617 8.78779 11.3044 8.78779 10.8637V7.80636V6.2104V2.69105L9.82787 3.74411C9.98182 3.89999 10.1836 3.97792 10.3851 3.97792C10.5866 3.97792 10.7883 3.89999 10.9423 3.74411C11.2502 3.43264 11.2502 2.92725 10.9423 2.61577L8.58918 0.233276C8.43523 0.0774039 8.23373 0 8.03223 0C8.03013 0 8.02829 0 8.02619 0C8.02409 0 8.02225 0 8.02014 0C7.81864 0 7.61714 0.0774039 7.46319 0.233276L5.11007 2.61577C4.80218 2.92725 4.80218 3.43264 5.11007 3.74411C5.26429 3.89999 5.46579 3.97792 5.66755 3.97792Z"
                                fill="#212529"
                              />
                            </svg>
                            <p class="mb-0 ml-2">{{ $t("dashboardPage.export") }}</p>
                          </div>
                        </b-button>
                      </div>
                    </div>

                    <b-skeleton-table
                      v-if="!isTableMounted"
                      class="mt-2"
                      :rows="8"
                      :columns="tableFields.length"
                      :table-props="{ hover: true, responsive: true }"
                    ></b-skeleton-table>
                    <b-table
                      v-else
                      ref="docTable"
                      class="mt-2"
                      :table-class="documentType === 'live_view' ? 'live-view-table' : ''"
                      responsive
                      :fields="tableFields"
                      :items="items"
                      hover
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :no-local-sorting="true"
                      :busy.sync="isBusy"
                      :sticky-header="'calc(100vh - 250px)'"
                      :show-empty="emptyTable"
                      :tbody-tr-class="rowClass"
                      @row-clicked="toggleRowDetails"
                    >
                      <template #head(plus)="">
                        <svg
                          width="8"
                          height="8"
                          viewBox="0 0 8 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.13956 4.42469H4.49356V7.14069H2.64556V4.42469H-0.000437468V2.71669H2.64556V0.00068748H4.49356V2.71669H7.13956V4.42469Z"
                            fill="black"
                          />
                        </svg>
                      </template>
                      <template #table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{ width: field.thStyle ? field.thStyle.width : null }"
                        />
                      </template>
                      <template #cell(plus)="row">
                        <button
                          v-if="row.item.num_docs"
                          type="button"
                          class="lv-expand-btn"
                          @click.stop="row.toggleDetails"
                        >
                          {{ row.detailsShowing ? "−" : "+" }}
                        </button>
                        <span v-else>-</span>
                      </template>
                      <template #cell(name)="data">
                        <p class="mb-0">{{ data.value }}</p>
                      </template>
                      <template #cell(missing_doc_type_ids)="data">
                        <div>
                          {{ data.value.length ? getDocTypeID(data.value) : "-" }}
                        </div>
                      </template>
                      <template #cell(type)="data">
                        {{ data.value ? data.value : "-" }}
                      </template>
                      <!-- <template #cell(location)="data">
                        <v-app class="d-contents align-items-center">
                          <v-tooltip top>
                            <template #activator="{ on, attrs }">
                              <span class="lv-ellipsis" v-on="on" v-bind="attrs">{{
                                data.value ? data.value : "-"
                              }}</span>
                            </template>
                            {{ data.value ? data.value : "-" }}
                          </v-tooltip>
                        </v-app>
                      </template> -->
                      <template #cell(driving)="data">
                        <div v-if="data.value" class="d-flex align-items-center">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.6558 5.09C11.6233 5.09917 5.6325 7.47667 5.6325 7.47667C5.18707 7.65039 4.80685 7.95861 4.54472 8.35845C4.28259 8.7583 4.15158 9.2299 4.16992 9.70766C4.18825 10.1854 4.35501 10.6456 4.64701 11.0242C4.93901 11.4027 5.34174 11.6809 5.79917 11.82L7.75417 12.3092L8.39834 14.4125C8.56972 14.8329 8.86258 15.1926 9.23948 15.4457C9.61637 15.6988 10.0602 15.8338 10.5142 15.8333H10.5508C11.0117 15.8274 11.46 15.682 11.8366 15.4164C12.2133 15.1507 12.5006 14.7772 12.6608 14.345C12.6608 14.345 14.905 8.37417 14.9108 8.345C15.029 7.89447 15.0271 7.42084 14.9054 6.97126C14.7836 6.52169 14.5462 6.11185 14.2168 5.78254C13.8874 5.45323 13.4775 5.21594 13.0279 5.09429C12.5783 4.97264 12.1047 4.97087 11.6542 5.08917L11.6558 5.09ZM13.3083 7.88917L11.1017 13.7583C11.0592 13.8774 10.981 13.9805 10.8778 14.0536C10.7746 14.1267 10.6514 14.1661 10.525 14.1667C10.4417 14.1567 10.0875 14.145 9.9625 13.8517L9.20584 11.3717C9.16402 11.2341 9.08733 11.1097 8.98322 11.0106C8.8791 10.9114 8.75111 10.8409 8.61167 10.8058L6.26334 10.2225C6.13974 10.1804 6.03211 10.1013 5.95511 9.99588C5.8781 9.89045 5.83547 9.76385 5.83301 9.63331C5.83055 9.50278 5.86838 9.37466 5.94136 9.2664C6.01434 9.15815 6.11891 9.07502 6.24084 9.02833L12.1242 6.695C12.2862 6.6563 12.4555 6.66055 12.6154 6.70732C12.7753 6.75408 12.9202 6.84175 13.0358 6.96167C13.1566 7.08018 13.2451 7.22762 13.2928 7.38996C13.3405 7.55231 13.3458 7.72416 13.3083 7.88917ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0V0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99076 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27289 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7118 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z"
                              fill="#2CCE89"
                            />
                          </svg>
                        </div>
                        <div v-else class="d-flex align-items-center">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.6558 5.09C11.6233 5.09917 5.6325 7.47667 5.6325 7.47667C5.18707 7.65039 4.80685 7.95861 4.54472 8.35845C4.28259 8.7583 4.15158 9.2299 4.16992 9.70766C4.18825 10.1854 4.35501 10.6456 4.64701 11.0242C4.93901 11.4027 5.34174 11.6809 5.79917 11.82L7.75417 12.3092L8.39834 14.4125C8.56972 14.8329 8.86258 15.1926 9.23948 15.4457C9.61637 15.6988 10.0602 15.8338 10.5142 15.8333H10.5508C11.0117 15.8274 11.46 15.682 11.8366 15.4164C12.2133 15.1507 12.5006 14.7772 12.6608 14.345C12.6608 14.345 14.905 8.37417 14.9108 8.345C15.029 7.89447 15.0271 7.42084 14.9054 6.97126C14.7836 6.52169 14.5462 6.11185 14.2168 5.78254C13.8874 5.45323 13.4775 5.21594 13.0279 5.09429C12.5783 4.97264 12.1047 4.97087 11.6542 5.08917L11.6558 5.09ZM13.3083 7.88917L11.1017 13.7583C11.0592 13.8774 10.981 13.9805 10.8778 14.0536C10.7746 14.1267 10.6514 14.1661 10.525 14.1667C10.4417 14.1567 10.0875 14.145 9.9625 13.8517L9.20584 11.3717C9.16402 11.2341 9.08733 11.1097 8.98322 11.0106C8.8791 10.9114 8.75111 10.8409 8.61167 10.8058L6.26334 10.2225C6.13974 10.1804 6.03211 10.1013 5.95511 9.99588C5.8781 9.89045 5.83547 9.76385 5.83301 9.63331C5.83055 9.50278 5.86838 9.37466 5.94136 9.2664C6.01434 9.15815 6.11891 9.07502 6.24084 9.02833L12.1242 6.695C12.2862 6.6563 12.4555 6.66055 12.6154 6.70732C12.7753 6.75408 12.9202 6.84175 13.0358 6.96167C13.1566 7.08018 13.2451 7.22762 13.2928 7.38996C13.3405 7.55231 13.3458 7.72416 13.3083 7.88917ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0V0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99076 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27289 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7118 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z"
                              fill="#C4C4C4"
                            />
                          </svg>
                        </div>
                      </template>
                      <template #cell(note)="data">
                        <v-app v-if="data.value" class="d-contents align-items-center">
                          <v-tooltip top>
                            <template #activator="{ on, attrs }">
                              <span
                                class="w-fit-content item-description text-left maxw-200px"
                                v-on="on"
                                v-bind="attrs"
                                >{{ htmlToPlainText(data.value) }}</span
                              > </template
                            >{{ formatTooltipText(htmlToPlainText(data.value)) }}
                          </v-tooltip>
                          <svg
                            @click="editNote(data.item)"
                            class="ml-2 cursor-pointer"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                              fill="#2CCE89"
                            />
                          </svg>
                        </v-app>
                        <span v-else class="d-flex"
                          >-
                          <svg
                            @click="editNote(data.item)"
                            class="ml-2 cursor-pointer"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                              fill="#2CCE89"
                            />
                          </svg>
                        </span>
                      </template>
                      <template #cell(date)="data">
                        <span v-html="data.value"></span>
                      </template>
                      <template #cell(num_docs)="data">
                        <span :style="data.item.color" class="docs-circle">{{
                          data.value
                        }}</span>
                      </template>
                      <template #cell(tags)="data">
                        <div v-if="data.value.length" class="d-flex align-items-center">
                          <div class="table-tags mr-2">{{ data.value[0] }}</div>
                          <v-app>
                            <v-tooltip bottom v-if="data.value.length > 1">
                              <template #activator="{ on, attrs }">
                                <div class="table-tags" v-on="on" v-bind="attrs">
                                  +{{ data.value.length - 1 }}
                                </div>
                              </template>
                              <span v-html="data.value.slice(1).join('<br>')"></span>
                            </v-tooltip>
                          </v-app>
                        </div>
                        <p class="mb-0" v-else>-</p>
                      </template>
                      <template #cell(description)="data">
                        <v-app>
                          <v-tooltip top>
                            <template #activator="{ on, attrs }">
                              <span
                                class="w-fit-content item-description text-left"
                                v-on="on"
                                v-bind="attrs"
                                >{{ data.value }}</span
                              > </template
                            >{{ data.value }}
                          </v-tooltip>
                        </v-app>
                      </template>
                      <template #cell(days)="data">
                        <span :style="data.item.color"
                          >{{ data.value }} {{ $t("dashboardPage.daysSuffix") }}</span
                        >
                      </template>
                      <template #cell(action)="data">
                        <span v-if="documentType !== 'required_docs'">
                          <svg
                            @click="addDoc(data.item)"
                            class="cursor-pointer mr-4"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="10" cy="10" r="10" fill="#2D69F6" />
                            <path
                              d="M10 13.3334V10.0001V13.3334ZM10 10.0001V6.66675V10.0001ZM10 10.0001H13.3334H10ZM10 10.0001H6.66669H10Z"
                              fill="#2D69F6"
                            />
                            <path
                              d="M10 13.3334V10.0001M10 10.0001V6.66675M10 10.0001H13.3334M10 10.0001H6.66669"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                          </svg>
                          <svg
                            @click="openDoc(data.item)"
                            class="cursor-pointer mr-4"
                            width="20"
                            height="15"
                            viewBox="0 0 20 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                              stroke="#2D69F6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                              stroke="#2D69F6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            @click="downloadDoc(data.item)"
                            class="mr-4 cursor-pointer"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                              stroke="#FFC800"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.0001 14.8497V5.15741"
                              stroke="#FFC800"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                              stroke="#FFC800"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            @click="showSnoozePopup(data.item.id)"
                            class="cursor-pointer mr-4"
                            v-if="
                              documentType !== 'no_notify' &&
                              !allowUpdateOwnerOperatorDocs
                            "
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.857 17.082C16.7202 16.8614 18.5509 16.4217 20.311 15.772C18.8204 14.1208 17.9967 11.9745 18 9.75V9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9V9.75C6.00302 11.9746 5.17899 14.121 3.688 15.772C5.421 16.412 7.248 16.857 9.143 17.082M14.857 17.082C12.959 17.3071 11.041 17.3071 9.143 17.082M14.857 17.082C15.0011 17.5319 15.0369 18.0094 14.9616 18.4757C14.8862 18.942 14.7018 19.384 14.4234 19.7656C14.1449 20.1472 13.7803 20.4576 13.3592 20.6716C12.9381 20.8856 12.4724 20.9972 12 20.9972C11.5276 20.9972 11.0619 20.8856 10.6408 20.6716C10.2197 20.4576 9.85507 20.1472 9.57662 19.7656C9.29817 19.384 9.11376 18.942 9.03841 18.4757C8.96306 18.0094 8.9989 17.5319 9.143 17.082M10.5 8.25H13.5L10.5 12.75H13.5"
                              stroke="#798AEB"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>

                          <svg
                            v-if="
                              checkDeleteDocsStatus(data.item) &&
                              !allowUpdateOwnerOperatorDocs
                            "
                            @click="showArchivePopup(data.item.id)"
                            class="cursor-pointer mr-4"
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.6154 4.40909L17.0385 14.0745C17.0074 14.5955 16.7753 15.0851 16.3897 15.443C16.0041 15.8009 15.4942 16.0002 14.9643 16H5.03569C4.50581 16.0002 3.99589 15.8009 3.6103 15.443C3.22471 15.0851 2.99262 14.5955 2.96154 14.0745L2.38462 4.40909M8.15385 7.81818H11.8462M2.03846 4.40909H17.9615C18.5348 4.40909 19 3.95091 19 3.38636V2.02273C19 1.45818 18.5348 1 17.9615 1H2.03846C1.46523 1 1 1.45818 1 2.02273V3.38636C1 3.95091 1.46523 4.40909 2.03846 4.40909Z"
                              stroke="#FF7900"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            @click="showPopup(data.item.id)"
                            class="cursor-pointer"
                            v-if="checkDeleteDocsStatus(data.item)"
                            width="19"
                            height="20"
                            viewBox="0 0 19 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 5.15704H17.6139"
                              stroke="#FF0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                              stroke="#FF0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                              stroke="#FF0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.23175 9.3065V14.8466"
                              stroke="#FF0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.385 9.3065V14.8466"
                              stroke="#FF0000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        <svg
                          v-else-if="
                            documentType === 'required_docs' &&
                            checkCreateDocStatus(data.item.type)
                          "
                          @click="addRequiredDoc(data.item)"
                          class="cursor-pointer mr-4"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="10" cy="10" r="10" fill="#2D69F6" />
                          <path
                            d="M10 13.3334V10.0001V13.3334ZM10 10.0001V6.66675V10.0001ZM10 10.0001H13.3334H10ZM10 10.0001H6.66669H10Z"
                            fill="#2D69F6"
                          />
                          <path
                            d="M10 13.3334V10.0001M10 10.0001V6.66675M10 10.0001H13.3334M10 10.0001H6.66669"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                        <span v-else>-</span>
                      </template>
                      <template #row-details="row">
                        <b-table
                          class="mb-0"
                          table-class="live-view-table live-view-details"
                          :fields="tableFields"
                          :items="row.item.documents"
                          thead-class="d-none"
                        >
                          <template #table-colgroup="scope">
                            <col
                              v-for="(field, index) in scope.fields"
                              :key="field.key"
                              :style="{
                                width: columnWidths[index]
                                  ? columnWidths[index] + 'px'
                                  : field.thStyle
                                  ? field.thStyle.width
                                  : null,
                              }"
                            />
                          </template>
                          <template #cell(plus)=""><span></span></template>
                          <template #cell(name)="data">
                            <p class="mb-0">
                              {{ data.item.name ? data.item.name : "-" }}
                            </p>
                          </template>
                          <template #cell(vehicle)="data">
                            <span class="text-capitalize">{{
                              data.item.type ? data.item.type : "-"
                            }}</span>
                          </template>
                          <template #cell(trailer)="data">
                            <v-app
                              v-if="
                                data.item.description && data.item.description !== 'null'
                              "
                            >
                              <v-tooltip top>
                                <template #activator="{ on, attrs }">
                                  <span
                                    class="w-fit-content item-description text-left"
                                    v-on="on"
                                    v-bind="attrs"
                                    >{{
                                      data.item.description ? data.item.description : "-"
                                    }}</span
                                  > </template
                                >{{ data.item.description ? data.item.description : "-" }}
                              </v-tooltip>
                            </v-app>
                            <p v-else>-</p>
                          </template>
                          <template #cell(num_docs)=""><span></span></template>
                          <template #cell(location)="data">
                            <span v-if="data.item.is_missing" class="lv-missing-badge">
                              {{ $t("dashboardPage.missingLabel") }}
                            </span>
                            <span v-else :style="expiryColor(data.item.expiry_date)">
                              {{ formatExpiryDate(data.item.expiry_date) }}
                            </span>
                          </template>
                          <template #cell(driving)="data">
                            <svg
                              @click="
                                data.item.is_missing
                                  ? addRequiredDoc(data.item)
                                  : addDoc(data.item)
                              "
                              class="cursor-pointer"
                              :class="!data.item.is_missing ? 'mr-4' : ''"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="10" cy="10" r="10" fill="#2D69F6" />
                              <path
                                d="M10 13.3334V10.0001V13.3334ZM10 10.0001V6.66675V10.0001ZM10 10.0001H13.3334H10ZM10 10.0001H6.66669H10Z"
                                fill="#2D69F6"
                              />
                              <path
                                d="M10 13.3334V10.0001M10 10.0001V6.66675M10 10.0001H13.3334M10 10.0001H6.66669"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                            <svg
                              @click="openDoc(data.item)"
                              v-if="!data.item.is_missing"
                              class="cursor-pointer"
                              width="20"
                              height="15"
                              viewBox="0 0 20 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                stroke="#2D69F6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                stroke="#2D69F6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </template>
                        </b-table>
                      </template>
                    </b-table>
                    <div class="entries-pagination px-0 px-sm-2">
                      <div class="d-flex align-items-center flex-wrap">
                        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                          <b-form-select v-model="perPage" :options="pageOptions" />
                        </div>
                        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0">{{ positionText }}</p>
                        <div class="pagination">
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                          ></b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- <b-col lg="4" md="8" sm="12" class="mx-auto my-1">
            <b-card img-top class="profile-card mb-2 bg-white" style="background: white !important">
              <b-card-text class="card-detail">
                <div class="user_photo text-center mb-3">
                  <b-img class="userImage rounded-circle" :src="user.team_member && user.team_member.profile_picture
                    ? user.team_member.profile_picture
                    : require('@/assets/user.png')
                    "></b-img>
                </div>
                <div class="card-title font-weight-bold mb-0">
                  {{ user.first_name }} {{ user.last_name }}
                </div>

                <div v-if="user && user.team_member" class="designation mb-3 f-14">
                  <div>
                    {{ user.team_member.role }}
                  </div>
                </div>
                <div class="w-100 text-center mt-5">
                  <p class="f-14">{{ user.email }}</p>
                  <p class="f-14">{{ user.team_member.phone }}</p>
                </div>
              </b-card-text>
              <b-button variant="primary" class="my-5 save text-white text-center" to="/profile-page">View
                Profile</b-button>
            </b-card>
          </b-col> -->
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="modal-document"
      centered
      @show="rememberScroll"
      @hidden="restoreScroll"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      :body-class="'px-3 pt-2 overflow-preview-auto'"
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :header-class="'align-items-center'"
      scrollable
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dashboardPage.documentModalTitle") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t("dashboardPage.closeModal") }}
        </b-button>
        <b-dropdown id="dropdown-preview" class="load-dropdown mt-0">
          <template slot="button-content">
            <b-icon class="dots" icon="three-dots"></b-icon>
          </template>
          <b-dropdown-item-button
            :class="
              checkUpdateDocsStatus() || checkDeleteDocsStatus(documentData) ? 'mb-2' : ''
            "
            @click="downloadDoc(documentData)"
          >
            <p class="text_secondary cursor-pointer mb-0 f-14">
              {{ $t("dashboardPage.download") }}
            </p>
          </b-dropdown-item-button>
          <b-dropdown-item-button
            :class="checkDeleteDocsStatus(documentData) ? 'mb-2' : ''"
            v-if="checkUpdateDocsStatus()"
            @click="removeFile()"
          >
            <p class="text_secondary cursor-pointer mb-0 f-14">
              {{ $t("dashboardPage.replaceDoc") }}
            </p>
          </b-dropdown-item-button>
          <b-dropdown-item-button
            @click="showArchivePopup(documentData.id)"
            class="mb-2"
            v-if="checkDeleteDocsStatus(documentData) && !allowUpdateOwnerOperatorDocs"
          >
            <p class="text_secondary cursor-pointer mb-0 f-14">
              {{ $t("dashboardPage.archive") }}
            </p>
          </b-dropdown-item-button>
          <b-dropdown-item-button
            @click="showPopup(documentData.id)"
            v-if="checkDeleteDocsStatus(documentData)"
          >
            <p class="text_secondary cursor-pointer mb-0 f-14">
              {{ $t("dashboardPage.delete") }}
            </p>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
      <div class="d-block text-center">
        <b-row>
          <b-col lg="4" md="8" sm="12">
            <div class="text-left mb-3" v-if="!allowUpdateOwnerOperatorDocs">
              <label class="state">{{ $t("dashboardPage.nameLabel") }}</label>
              <v-select
                class="bg_white w-100 f-12"
                v-model="modelName"
                :options="nameOptions"
                item-value="id"
                item-text="label"
                :reduce="(option) => option.id"
                @option:selected="getNameItem($event)"
                :disabled="!checkUpdateDocsStatus()"
                @search="searchAssets"
              >
                <span slot="no-options">
                  {{ $t("dashboardPage.searchUnitOrName") }}
                </span>
              </v-select>
              <p v-if="errors && errors.name" class="field-error">
                {{ errors.name[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label for="modal-datepicker" class="state">{{
                $t("dashboardPage.dateLabel")
              }}</label>
              <date-picker
                v-model="documentData.date"
                :formatter="momentFormat"
                :range-separator="' - '"
                @clear="documentData.date = ''"
                :placeholder="$t('dashboardPage.selectDate')"
                class="date-picker-custom"
                :disabled="!checkUpdateDocsStatus()"
                :teleport="'body'"
              ></date-picker>
              <p v-if="errors && errors.date" class="field-error">
                {{ errors.date[0] }}
              </p>
            </div>

            <div class="text-left mb-3">
              <label for="modal-expiry-date" class="state">{{
                $t("dashboardPage.expiryDateLabel")
              }}</label>
              <date-picker
                v-model="documentData.expiry_date"
                :formatter="momentFormat"
                :range-separator="' - '"
                @clear="documentData.expiry_date = ''"
                :placeholder="$t('dashboardPage.selectDate')"
                class="date-picker-custom"
                :disabled="!checkUpdateDocsStatus()"
                :teleport="'body'"
              ></date-picker>
            </div>
            <div class="text-left mb-3" v-if="showDivision">
              <label class="state">{{ $t("dashboardPage.divisionLabel") }}</label>
              <v-select
                class="f-12"
                :clearable="false"
                :options="allDivisions"
                v-model="documentData.division"
                :disabled="!checkUpdateDocsStatus()"
                :reduce="(option) => option.id"
              />
            </div>
            <div class="text-left mb-3" v-if="isTagDoc">
              <label class="state">{{ $t("dashboardPage.modelLabel") }}</label>
              <b-form-select
                class="f-12"
                :options="taggedModelOptions"
                v-model="documentData.tagged_model"
                :disabled="!checkUpdateDocsStatus()"
              >
              </b-form-select>
              <p v-if="errors && errors.tagged_model" class="field-error">
                {{ errors.doc_type[0] }}
              </p>
            </div>
            <div class="text-left mb-3" v-if="isTagDoc">
              <label class="state">{{ $t("dashboardPage.tagsLabel") }}</label>
              <v-select
                class="f-12"
                :options="docTags"
                multiple
                :reduce="(option) => option.id"
                v-model="documentData.tags"
                :disabled="!checkUpdateDocsStatus()"
              />
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t("dashboardPage.typeLabel") }}</label>
              <b-form-select
                class="f-12"
                :options="getDotOptions"
                :disabled="!checkUpdateDocsStatus()"
                v-model="documentData.doc_type"
                @change="setDocDescription($event)"
              >
              </b-form-select>
              <p v-if="errors && errors.doc_type" class="field-error">
                {{ errors.doc_type[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t("dashboardPage.descriptionLabel") }}</label>
              <b-form-textarea
                id="textarea"
                :disabled="!checkUpdateDocsStatus()"
                :placeholder="$t('dashboardPage.descriptionPlaceholder')"
                rows="3"
                v-model="documentData.description"
              ></b-form-textarea>
              <p v-if="errors && errors.description" class="field-error pb-4">
                {{ errors.description[0] }}
              </p>
            </div>
            <div class="text-left mb-3" v-if="!allowUpdateOwnerOperatorDocs">
              <label class="state">{{ $t("dashboardPage.driverLabel") }}</label>
              <b-form-checkbox
                class="ml-0-6rem"
                :disabled="!checkUpdateDocsStatus()"
                v-model="documentData.driver"
                name="driver-button"
                switch
                size="lg"
              />
            </div>
            <div class="text-left mb-3" v-if="!allowUpdateOwnerOperatorDocs">
              <label class="state">{{ $t("dashboardPage.dotModeLabel") }}</label>
              <b-form-checkbox
                :disabled="!checkUpdateDocsStatus()"
                v-model="documentData.dot_mode"
                name="check-button"
                switch
                size="lg"
                class="ml-0-6rem"
              />
            </div>
            <div class="text-left" v-if="showPublic && !allowUpdateOwnerOperatorDocs">
              <label class="state">{{ $t("dashboardPage.publicLabel") }}</label>
              <b-form-checkbox
                :disabled="!checkUpdateDocsStatus()"
                v-model="documentData.public"
                name="check-button"
                switch
                size="lg"
                class="ml-0-6rem"
              />
            </div>
          </b-col>
          <b-col lg="8" sm="12">
            <div class="upload-btn-wrapper" v-if="!fileName">
              <b-img :src="require('@/assets/drop.svg')"></b-img>
              <button v-if="!fileName" class="foo">
                {{ $t("dashboardPage.dropDocument") }}
              </button>
              <button v-else class="foo">{{ fileName }}</button>

              <input
                ref="docFile"
                type="file"
                name="docFile"
                v-on:change="handleFileUpload"
                accept=".pdf, .png, .jpg, .jpeg"
              />
              <p v-if="errors && errors.document" class="field-error">
                {{ errors.document[0] }}
              </p>
            </div>
            <div v-else>
              <div
                class="review-media-section"
                :class="mediaType === 'pdf' ? 'overflow-hidden' : ''"
              >
                <iframe
                  class="w-100 h-100 border-0"
                  v-if="mediaType === 'pdf'"
                  :src="media"
                ></iframe>
                <div v-else>
                  <div id="panzoom-element" ref="panzoomElement">
                    <img :src="media" class="w-100 h-100 img-section" />
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-center zoom-section"
                  >
                    <b-icon
                      @click="zoom(1)"
                      icon="zoom-in"
                      style="fill: white; cursor: pointer"
                    ></b-icon>
                    <b-icon
                      @click="zoom(-1)"
                      class="ml-3"
                      icon="zoom-out"
                      style="fill: white; cursor: pointer"
                    ></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mt-4">
          <b-button
            class="mx-0 h-40px w-100px m-0"
            :class="hasChanged && checkUpdateDocsStatus() ? 'mr-3' : ''"
            block
            @click="
              $bvModal.hide('modal-document');
              panzoom = null;
            "
            >{{ $t("dashboardPage.close") }}</b-button
          >
          <b-button
            class="mx-0 mb-0 h-40px w-100px m-0"
            variant="primary"
            @click="sendDocumentData"
            v-if="hasChanged && checkUpdateDocsStatus()"
            >{{ $t("dashboardPage.save") }}</b-button
          >
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-filter"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :body-class="'px-3 pt-2 overflow-preview-auto'"
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :header-class="'align-items-center'"
      :scrollable="documentType !== 'live_view'"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dashboardPage.filtersModalTitle") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t("dashboardPage.closeModal") }}
        </b-button>
      </template>
      <div class="body" v-if="documentType === 'live_view'">
        <b-form-group
          :label="$t('dashboardPage.filterTags')"
          class="text-left w-equipment-box mb-3"
        >
          <v-select
            append-to-body
            multiple
            class="f-12 bg-grey"
            :options="docTags"
            :reduce="(option) => option.id"
            v-model="filterFields.tags"
            @input="getDocuments()"
          />
        </b-form-group>
      </div>
      <div
        class="body"
        v-else-if="documentType !== 'required_docs' && documentType !== 'live_view'"
      >
        <b-form-group
          :label="$t('dashboardPage.filterType')"
          class="text-left select_arrow label mb-3"
        >
          <b-form-select
            type="text"
            class="input f-12"
            required
            v-model="filterFields.type"
            :options="typeOptions"
            @change="setDocTypeData()"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterDocType')"
          class="text-left select_arrow label mb-3"
        >
          <b-form-select
            v-model="filterFields.doc_type"
            class="f-12"
            @change="getDocuments()"
            :disabled="docTypeOptions.length === 0"
            :options="docTypeOptions.length > 0 ? docTypeOptions : selectDocTypeFallback"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterTags')"
          class="text-left w-equipment-box mb-3"
        >
          <v-select
            append-to-body
            multiple
            class="f-12 bg-grey"
            :options="docTags"
            :reduce="(option) => option.id"
            v-model="filterFields.tags"
            @input="getDocuments()"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterExcludeTags')"
          class="text-left mb-3"
        >
          <v-select
            append-to-body
            multiple
            :options="docTags"
            class="f-12"
            :reduce="(option) => option.id"
            v-model="filterFields.exclude_tags"
            :placeholder="$t('dashboardPage.selectExcludeTags')"
            @input="getDocuments()"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterExpiryDays')"
          class="text-left select_arrow label mb-3"
        >
          <b-form-select
            type="number"
            class="input f-12"
            required
            v-model="filterFields.expiry_days"
            :options="expiryDaysOptions"
            @change="getDocuments()"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterDivision')"
          class="text-left select_arrow label mb-3"
        >
          <v-select
            append-to-body
            multiple
            :options="allDivisions"
            class="f-12"
            :reduce="(option) => option.id"
            :placeholder="$t('dashboardPage.selectDivision')"
            v-model="filterFields.division"
            @input="getDocuments()"
          />
        </b-form-group>
      </div>
      <div class="body" v-else>
        <b-form-group
          :label="$t('dashboardPage.filterRequired')"
          class="text-left w-equipment-box select_arrow label mb-3"
        >
          <b-form-select
            v-model="filterFields.required"
            class="f-12"
            @change="getDocuments()"
            :options="requiredOptions"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterType')"
          class="text-left select_arrow label mb-3"
        >
          <b-form-select
            v-model="filterFields.type"
            class="f-12"
            @change="setDocTypeData()"
            :options="typeOptions"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterDocType')"
          class="text-left select_arrow label mb-3"
        >
          <b-form-select
            v-model="filterFields.doc_type"
            class="f-12"
            @change="getDocuments()"
            :disabled="docTypeOptions.length === 0"
            :options="docTypeOptions.length > 0 ? docTypeOptions : selectDocTypeFallback"
          />
        </b-form-group>
        <b-form-group :label="$t('dashboardPage.filterTags')" class="text-left mb-3">
          <v-select
            append-to-body
            multiple
            :options="docTags"
            class="f-12"
            :reduce="(option) => option.id"
            v-model="filterFields.tags"
            :placeholder="$t('dashboardPage.selectTags')"
            @input="getDocuments()"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterExcludeTags')"
          class="text-left mb-3"
        >
          <v-select
            append-to-body
            multiple
            :options="docTags"
            class="f-12"
            :reduce="(option) => option.id"
            v-model="filterFields.exclude_tags"
            :placeholder="$t('dashboardPage.selectExcludeTags')"
            @input="getDocuments()"
          />
        </b-form-group>
        <b-form-group
          :label="$t('dashboardPage.filterDivision')"
          class="text-left select_arrow label mb-3"
        >
          <v-select
            append-to-body
            multiple
            :options="allDivisions"
            class="f-12"
            :reduce="(option) => option.id"
            :placeholder="$t('dashboardPage.selectDivision')"
            v-model="filterFields.division"
            @input="getDocuments()"
          />
        </b-form-group>
      </div>
      <template #modal-footer="">
        <div
          class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0"
        >
          <b-button
            class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary"
            variant="primary"
            @click="
              resetFilterFields();
              $bvModal.hide('modal-filter');
            "
            >{{ $t("dashboardPage.reset") }}</b-button
          >
          <b-button
            class="mx-0 h-40px w-100px m-0 m-0"
            block
            @click="$bvModal.hide('modal-filter')"
            >{{ $t("dashboardPage.close") }}</b-button
          >
        </div>
      </template>
    </b-modal>

    <DeleteModal
      v-if="showDocumentModal"
      @confirm="deleteDocumentItem($event)"
      :message="$t('dashboardPage.confirmDeleteDoc')"
    />
    <DeleteModal
      :message="$t('dashboardPage.confirmArchiveDoc')"
      :updateMessage="true"
      :removeMessage="''"
      v-if="showArchiveDocumentModal"
      @confirm="archiveDocumentItem($event)"
    />
    <DeleteModal
      :message="getSnoozeMessage()"
      :updateMessage="true"
      :removeMessage="''"
      v-if="showSnoozeDocumentModal"
      @confirm="snoozeDocumentItem($event)"
    />
    <NotesSection
      :noteURL="'app/expirydata/notes'"
      :title="$t('dashboardPage.editNoteTitle')"
      :docId="docId"
      @updateNotes="getDocuments()"
      :edit="false"
      :notesData="notesData"
      @clearNote="
        notesData = null;
        docId = null;
      "
    />
    <AddDoc :docData="docData" @close="docData = null" @onAddDoc="getDocuments()" />
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueMask from "v-mask";
import Vue from "vue";
import * as moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkValueExists, checkDescriptionLength } from "../../services/helper";
import Panzoom from "@panzoom/panzoom";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import NotesSection from "@/components/Shared/Notes/NotesSection.vue";
import AddDoc from "@/components/Reports/AddDoc.vue";
Vue.use(VueMask);

export default {
  name: "Dashboard",
  components: { vSelect, DeleteModal, DatePicker, NotesSection, AddDoc },
  computed: {
    ...mapGetters([
      "user",
      "documents",
      "allCountries",
      "singleDoc",
      "userCompany",
      "docTypeItems",
      "company",
      "defaultDocType",
      "divisions",
      "rolePermissions",
      "tags",
    ]),
    allDivisions() {
      return this.divisions.map((item) => {
        return {
          id: item.id,
          label: item.division,
        };
      });
    },
    tableFields() {
      if (this.documentType === "required_docs") {
        return [
          {
            label: this.$t("dashboardPage.colName"),
            key: "name",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
            stickyColumn: true,
          },
          {
            label: this.$t("dashboardPage.colType"),
            key: "type",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colDivision"),
            key: "division",
            sortable: true,
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colDocType"),
            key: "missing_doc_type_ids",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colTags"),
            key: "tags",
            sortable: true,
            tdClass: "align-middle",
            visible: false,
            disabled: false,
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colAction"),
            key: "action",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
        ];
      }
      if (this.documentType === "live_view") {
        return [
          {
            label: "",
            key: "plus",
            sortable: false,
            tdClass: "align-middle pl-0-3-5",
            thClass: "font-table-weight-bold",
            thStyle: { minWidth: "30px", width: "30px" },
          },
          {
            label: this.$t("dashboardPage.colName"),
            key: "name",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colVehicle"),
            key: "vehicle",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colTrailer"),
            key: "trailer",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colDocs"),
            key: "num_docs",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colLocation"),
            key: "location",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          {
            label: this.$t("dashboardPage.colDriving"),
            key: "driving",
            sortable: true,
            tdClass: "align-middle",
            field: "text",
            thClass: "font-table-weight-bold",
          },
          // {
          //   label: this.$t("dashboardPage.colAction"),
          //   key: "expand",
          //   tdClass: "align-middle",
          //   thClass: "font-table-weight-bold",
          //   sortable: true,
          // },
        ];
      }
      return [
        {
          label: this.$t("dashboardPage.colName"),
          key: "name",
          sortable: true,
          stickyColumn: true,
          thClass: "font-table-weight-bold",
        },
        {
          label: this.$t("dashboardPage.colType"),
          key: "type",
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          label: this.$t("dashboardPage.colDescription"),
          key: "description",
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          label: this.$t("dashboardPage.colExpiryDate"),
          key: "Date",
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        {
          label: this.$t("dashboardPage.colDays"),
          key: "Days",
          sortable: true,
          thClass: "font-table-weight-bold",
        },
        ...(this.allowUpdateOwnerOperatorDocs
          ? []
          : [
              {
                label: this.$t("dashboardPage.colNote"),
                key: "note",
                sortable: true,
                thClass: "font-table-weight-bold",
              },
              {
                label: this.$t("dashboardPage.colTags"),
                key: "tags",
                sortable: true,
                tdClass: "align-middle",
                visible: false,
                disabled: false,
                field: "text",
                thClass: "font-table-weight-bold",
              },
            ]),
        {
          key: "Action",
          label: this.$t("dashboardPage.colAction"),
          sortable: true,
          visible: true,
          disabled: true,
          field: "text",
          thClass: "font-table-weight-bold",
        },
      ];
    },
    taggedModelOptions() {
      return [
        { text: "-", value: "-" },
        { text: this.$t("dashboardPage.modelVehicle"), value: "Vehicle" },
        { text: this.$t("dashboardPage.modelTrailer"), value: "Trailer" },
        { text: this.$t("dashboardPage.modelDriver"), value: "Driver" },
      ];
    },
    expiryDaysOptions() {
      return [
        { value: null, text: "" },
        { value: "15", text: "0-15" },
        { value: "31", text: "0-31" },
      ];
    },
    requiredOptions() {
      return [
        { value: "", text: "" },
        { value: "True", text: this.$t("dashboardPage.filterRequiredYes") },
        { value: "False", text: this.$t("dashboardPage.filterRequiredNo") },
      ];
    },
    selectDocTypeFallback() {
      return [{ value: "", text: this.$t("dashboardPage.selectDocType") }];
    },
    allowViewDocDrivers() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Drivers"] &&
        this.rolePermissions["Drivers"][7].allow
      );
    },
    allowViewDocEquipment() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Equipment"] &&
        this.rolePermissions["Equipment"][6].allow
      );
    },
    allowViewDocCompany() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Company Documents"] &&
        this.rolePermissions["Company Documents"][0].allow
      );
    },
    allowDeleteDocDrivers() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Drivers"] &&
        this.rolePermissions["Drivers"][10].allow
      );
    },
    allowDeleteDocEquipment() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Equipment"] &&
        this.rolePermissions["Equipment"][9].allow
      );
    },
    allowDeleteDocCompany() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Company Documents"] &&
        this.rolePermissions["Company Documents"][3].allow
      );
    },
    allowUpdateOwnerOperatorDocs() {
      return this.$store.state?.user?.user?.team_member?.role === "Owner Operator";
    },
    summaryCardClasses() {
      // Mirror the exact column sizes/padding of the real cards so the skeletons
      // line up at every breakpoint.
      if (this.allowUpdateOwnerOperatorDocs) {
        return [
          { xl: 4, class: "px-3 pr-lg-0 mt-3" },
          { xl: 4, class: "px-3 mt-3" },
          { xl: 4, class: "px-3 mt-3 pl-lg-0" },
        ];
      }
      return [
        { xl: 3, class: "px-3 pr-lg-0 mt-3" },
        { xl: 3, class: "px-3 mt-3 pr-xl-3 pr-lg-0" },
        { xl: 3, class: "px-3 px-xl-0 mt-3" },
        { xl: 3, class: "px-3 pr-xl-3 pr-lg-0 mt-3" },
        { xl: 3, class: "px-3 pr-lg-0 mt-3" },
        { xl: 3, class: "px-3 mt-3" },
        { xl: 3, class: "px-3 px-xl-0 pr-lg-0 mt-3" },
        { xl: 3, class: "px-3 pr-xl-3 pr-lg-0 mt-3" },
      ];
    },
    allowUpdateDocDrivers() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Drivers"] &&
        this.rolePermissions["Drivers"][8].allow
      );
    },
    allowUpdateDocEquipment() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Equipment"] &&
        this.rolePermissions["Equipment"][7].allow
      );
    },
    allowUpdateDocCompany() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Company Documents"] &&
        this.rolePermissions["Company Documents"][1].allow
      );
    },
    allowCreateDocDrivers() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Drivers"] &&
        this.rolePermissions["Drivers"][9].allow
      );
    },
    allowCreateDocEquipment() {
      return (
        this.rolePermissions &&
        this.rolePermissions["Equipment"] &&
        this.rolePermissions["Equipment"][8].allow
      );
    },
    hasChanged() {
      return (
        Object.keys(this.documentData).filter((field) => {
          if (field !== "updated_at") {
            if (typeof this.documentData[field] === "object")
              return (
                JSON.stringify(this.documentData[field]) !==
                JSON.stringify(this.defaultData[field])
              );
            if (field === "description") {
              return (
                this.checkValueExists(
                  this.documentData[field]?.trim().replace(/\r\n|\r|\n/g, "\n")
                ) !=
                this.checkValueExists(
                  this.defaultData[field]?.trim().replace(/\r\n|\r|\n/g, "\n")
                )
              );
            } else if (!this.documentData[field] && !this.defaultData[field])
              return false;
            else
              return (
                this.checkValueExists(this.documentData[field]) !=
                this.checkValueExists(this.defaultData[field])
              );
          }
          return false;
        }).length > 0
      );
    },
    getDotOptions() {
      if (!this.allowUpdateOwnerOperatorDocs) {
        if (!this.modelName) return [];
        return [
          ...[
            {
              value: "",
              text: "",
            },
          ],
          ...this.docTypeItems
            ?.filter((item) => item.model === this.modelType || item.model === "All")
            .map((item) => {
              return {
                value: item.id,
                text: item.type,
              };
            }),
        ];
      }
      return [
        ...[
          {
            value: "",
            text: "",
          },
        ],
        ...this.docTypeItems.map((item) => {
          return {
            value: item.id,
            text: item.type,
          };
        }),
      ];
    },
    activeFiltersCount() {
      return Object.keys(this.filterFields).reduce((count, key) => {
        if (key === "tags") {
          return count + (this.filterFields.tags.length > 0 ? 1 : 0);
        }
        if (key === "division") {
          return count + (this.filterFields.division.length > 0 ? 1 : 0);
        }
        if (key === "exclude_tags") {
          return count + (this.filterFields.exclude_tags.length > 0 ? 1 : 0);
        } else if (key === "required" && this.documentType !== "required_docs") {
          return count;
        } else if (this.filterFields[key] !== "" && this.filterFields[key] !== null) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    typeOptions() {
      const options = [{ value: "", text: "" }];
      if (this.allowViewDocEquipment) {
        options.push({ value: "Vehicle", text: this.$t("dashboardPage.typeVehicle") });
        options.push({ value: "Trailer", text: this.$t("dashboardPage.typeTrailer") });
      }
      if (this.allowViewDocDrivers) {
        options.push({ value: "Driver", text: this.$t("dashboardPage.typeDriver") });
      }
      if (this.allowViewDocCompany) {
        options.push({ value: "Company", text: this.$t("dashboardPage.typeCompany") });
        options.push({ value: "Tag Doc", text: this.$t("dashboardPage.typeTagDoc") });
      }
      return options;
    },
  },
  methods: {
    ...mapActions([
      "getAllDocuments",
      "setNotification",
      "getEquipmentCount",
      "getTeamMembersCount",
      "postExcelData",
      "getFilteredEquipments",
      "getSingleDoc",
      "setLoader",
      "updateTeamMemberDocument",
      "retrieveDocument",
      "deleteCompanyDocument",
      "exportExpiryData",
      "exportLiveDocumentsData",
      "getDashboardStats",
      "getAllTags",
      "sendTeamMemberDocument",
      "getAllRequiredDocs",
      "exportAllRequiredDocsData",
      "getAllLiveDocuments",
    ]),
    checkCreateDocStatus(type) {
      if (type === "Driver" && this.allowCreateDocDrivers) return true;
      else if (
        (type === "Equipment" || type === "Vehicle" || type === "Trailer") &&
        this.allowCreateDocEquipment
      )
        return true;
      else return false;
    },
    setDocTypeData() {
      if (this.filterFields.type) {
        this.docTypeOptions = [
          ...[
            {
              value: "",
              text: this.$t("dashboardPage.selectDocType"),
            },
          ],
          ...this.docTypeItems
            ?.filter(
              (item) =>
                item.model === this.filterFields.type &&
                (!this.filterFields.required ||
                  (this.filterFields.required === "True" && item.required) ||
                  (this.filterFields.required === "False" && !item.required))
            )
            .map((item) => {
              return {
                value: item.id,
                text: item.type,
              };
            }),
        ];
      } else this.docTypeOptions = [];
      this.getDocuments();
    },
    getDocTypeID(data) {
      const docTypItems = data.map((id) => {
        const foundItem = this.docTypeItems.find((item) => item.id === id);
        if (foundItem) {
          return foundItem.type;
        }
      });
      return docTypItems.join(", ");
    },
    async addDoc(docData) {
      this.addDocument = false;
      this.docName = "";
      this.media = null;
      this.mediaID = null;
      this.mediaType = null;
      await this.getSingleDoc(docData.id);
      const data = this.items.filter((item) => item.id === docData.id)[0];
      this.addDocument = true;
      let typeofDoc = data?.type ? data?.type : docData.type;
      typeofDoc = typeofDoc.charAt(0).toUpperCase() + typeofDoc.slice(1);
      this.nameOptions = [
        {
          id: `${typeofDoc}-${
            typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
          }`,
          label: data?.name ? data?.name : docData.name,
          type: `${
            typeofDoc === "Company"
              ? "company"
              : typeofDoc === "Vehicle" || typeofDoc === "Trailer"
              ? "equipment"
              : "teammember"
          }`,
          name: data?.name ? data?.name : docData.name,
          model: typeofDoc === "Tag Doc" ? "Company" : typeofDoc,
        },
      ];
      this.nameOptions = [
        ...new Map(this.nameOptions.map((item) => [item["id"], item])).values(),
      ];
      this.showDivision = typeofDoc === "Company" ? true : false;
      this.showPublic = typeofDoc !== "Driver" ? true : false;
      this.modelType = typeofDoc === "Tag Doc" ? "Company" : typeofDoc;
      this.isTagDoc = typeofDoc === "Tag Doc";
      this.documentIndex = docData.id;
      this.documentData = this.singleDoc;
      this.documentData = {
        ...this.singleDoc,
        doc_type: this.singleDoc.doc_type_info.id,
        date: moment.tz(this.singleDoc.date, this.userTimeZone).toDate(),
        expiry_date: this.singleDoc.expiry_date
          ? moment.tz(this.singleDoc.expiry_date, this.userTimeZone).toDate()
          : "",
      };
      this.documentData.type = typeofDoc;
      this.documentData.name = `${typeofDoc}-${
        typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
      }`;
      this.modelName = `${typeofDoc}-${
        typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
      }`;
      this.documentData.docName = name;
      this.documentData.document = null;
      this.fileName = "";
      this.errors = {
        date: null,
        type: null,
        document: null,
        description: null,
        ...(this.company[0].doc_type ? { doc_type: null } : {}),
      };
      this.documentData.expiry_date = null;
      this.documentData.date = moment.tz(new Date(), this.userTimeZone).toDate();
      this.defaultData = JSON.parse(
        JSON.stringify({
          ...this.documentData,
          doc_type: this.singleDoc.doc_type_info.id
            ? this.singleDoc.doc_type_info.id
            : "",
        })
      );
      this.$bvModal.show("modal-document");
    },
    formatTooltipText(text) {
      const maxLineLength = window.screen.width <= 767 ? 50 : 80;
      let formattedText = "";
      let lineLength = 0;

      text.split(" ").forEach((word) => {
        if (lineLength + word.length + 1 > maxLineLength) {
          formattedText += "\n";
          lineLength = 0;
        }
        formattedText += (lineLength === 0 ? "" : " ") + word;
        lineLength += word.length + 1;
      });

      return formattedText;
    },
    editNote(data) {
      this.notesData = { note: data.note };
      this.docId = data.id;
      this.$bvModal.show("modal-notes-section");
    },
    htmlToPlainText(htmlString) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    checkUpdateDocsStatus() {
      if (this.documentData) return this.checkUpdateStatus(this.documentData.type);
      return false;
    },
    checkUpdateStatus(type) {
      if (this.allowUpdateOwnerOperatorDocs) return true;
      else if (type === "Driver" && this.allowUpdateDocDrivers) return true;
      else if (type === "Tag Doc" && this.allowUpdateDocCompany) return true;
      else if (type === "Company" && this.allowUpdateDocCompany) return true;
      else if (
        (type === "Equipment" || type === "Vehicle" || type === "Trailer") &&
        this.allowUpdateDocEquipment
      )
        return true;
      else return false;
    },
    checkDeleteDocsStatus(data) {
      if (this.allowUpdateOwnerOperatorDocs) return true;
      else if (data.type === "Driver" && this.allowDeleteDocDrivers) return true;
      else if (data.type === "Tag Doc" && this.allowDeleteDocCompany) return true;
      else if (data.type === "Company" && this.allowDeleteDocCompany) return true;
      else if (
        (data.type === "Equipment" ||
          data.type === "Vehicle" ||
          data.type === "Trailer") &&
        this.allowDeleteDocEquipment
      )
        return true;
      else return false;
    },
    zoom(level) {
      if (!this.panzoom) {
        this.panzoom = Panzoom(document.getElementById("panzoom-element"), {
          maxScale: 5,
        });
      }
      level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn();
    },
    setDocDescription(event) {
      if (event) {
        this.documentData.description = this.getDotOptions.filter(
          (option) => option.value === event
        )[0].text;
      } else this.documentData.description = "";
    },
    deleteDocumentItem(status) {
      if (status) {
        this.deleteDocument(this.itemId);
      }
      this.showDocumentModal = false;
    },
    snoozeDocumentItem(status) {
      if (status) {
        this.archiveOrSnoozedDocument(false);
      }
      this.showSnoozeDocumentModal = false;
    },
    archiveDocumentItem(status) {
      if (status) {
        this.archiveOrSnoozedDocument(true);
      }
      this.showArchiveDocumentModal = false;
    },
    async setDocumentType(type = "") {
      this.documentType = type;
      this.currentPage = 1;
      this.resetFilterFields();
    },
    async downloadDoc(data) {
      this.setLoader(true);
      const doc = await this.retrieveDocument(data.id);
      fetch(doc.document)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const newUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = newUrl;
          const urlWithoutParams = doc.document.split("?")[0];
          const extension = urlWithoutParams.split(".").pop();
          a.download = `${
            data.type !== "Company"
              ? data.docName
                ? data.docName
                : data.name
              : "Company"
          }-${data.description ? data.description.replace(/\./g, "") : ""}.${extension}`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(newUrl);
          a.remove();
          this.setLoader(false);
        })
        .catch((error) => {
          this.setLoader(false);
          console.log(error);
        });
    },
    async deleteDocument(id) {
      try {
        await this.deleteCompanyDocument(`${id}/?company_id=${this.userCompany}`);
        await this.setNotification({
          msg: this.$t("dashboardPage.docDeleted"),
          type: "success",
          color: "green",
        });
        await this.getDocuments();
        this.$bvModal.hide("modal-document");
      } catch (error) {
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async archiveOrSnoozedDocument(archive = true) {
      try {
        const data = this.items.filter((item) => this.itemId === item.id)[0];
        delete data.tags;
        await this.updateTeamMemberDocument({
          id: data.id,
          payload: {
            ...data,
            object_id: data.object_id,
            ...(archive ? { is_archived: true } : { is_snoozed: !data.is_snoozed }),
          },
        });
        await this.setNotification({
          msg: archive
            ? this.$t("dashboardPage.docArchived")
            : data.is_snoozed
            ? this.$t("dashboardPage.docUnsnoozed")
            : this.$t("dashboardPage.docSnoozed"),
          type: "success",
          color: "green",
        });
        await this.getDocuments();
        this.$bvModal.hide("modal-document");
      } catch (error) {
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    showPopup(id) {
      this.showDocumentModal = true;
      this.itemId = id;
    },
    showArchivePopup(id) {
      this.showArchiveDocumentModal = true;
      this.itemId = id;
    },
    showSnoozePopup(id) {
      this.showSnoozeDocumentModal = true;
      this.itemId = id;
    },
    getSnoozeMessage() {
      const data = this.items.filter((item) => this.itemId === item.id)[0];
      return data.is_snoozed
        ? this.$t("dashboardPage.confirmUnsnoozeDoc")
        : this.$t("dashboardPage.confirmSnoozeDoc");
    },
    downloadFile(uri) {
      axios({
        method: "get",
        url: uri,
        responseType: "blob",
      }).then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const fileName = this.docName;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    // Only live-view rows that actually have documents can expand.
    toggleRowDetails(item) {
      if (this.documentType !== "live_view" || !item.num_docs) return;
      this.$set(item, "_showDetails", !item._showDetails);
      this.$nextTick(this.measureColumns);
    },
    rowClass(item) {
      return this.documentType === "live_view" && item && item.num_docs
        ? "cursor-pointer"
        : "";
    },
    expiryColor(expiryDate) {
      if (!expiryDate) return "color:black";
      const diffDays = parseInt(
        (new Date(expiryDate) - new Date()) / (1000 * 60 * 60 * 24),
        10
      );
      if (diffDays > 30) return "color:black";
      if (diffDays >= 1) return "color:#FFC800";
      return "color:#FF0000";
    },
    formatExpiryDate(value) {
      return value ? moment(value).format("ll") : "-";
    },
    // Opening the preview locks body scroll and moves focus, which loses the reader's
    // place in both the page and the sticky-header table; capture it and put it back.
    // The parent table is content-sized, so the expanded rows can only line up if they
    // copy the widths the browser actually computed for it.
    // The parent is content-sized by the browser; the expanded rows simply copy the
    // widths it settled on, so the two can never disagree.
    measureColumns() {
      const wrapper = this.$refs.docTable && this.$refs.docTable.$el;
      if (!wrapper) return;
      const headers = wrapper.querySelectorAll("thead th");
      if (!headers.length) return;
      this.columnWidths = Array.from(headers).map(
        (th) => th.getBoundingClientRect().width
      );
    },
    rememberScroll() {
      this.savedScroll = {
        page: window.scrollY,
        table: this.$refs.docTable ? this.$refs.docTable.$el.scrollTop : 0,
      };
    },
    restoreScroll() {
      this.$nextTick(() => {
        window.scrollTo(0, this.savedScroll.page);
        if (this.$refs.docTable) {
          this.$refs.docTable.$el.scrollTop = this.savedScroll.table;
        }
      });
    },
    async openDoc(data) {
      this.addDocument = false;
      this.docName = `${data.name}-${
        data.description ? data.description.replace(/\./g, "") : ""
      }`;
      const doc = await this.retrieveDocument(data.id);
      this.media = doc.document;
      this.mediaID = data.id;
      if (doc.document.includes(".pdf")) this.mediaType = "pdf";
      else this.mediaType = "image";
      this.editDocument(data.id, data.name, data.type);
    },

    downloadURI(uri) {
      let link = document.createElement("a");
      link.setAttribute("href", uri);
      link.setAttribute("download", "export.csv");
      link.click();
      link.remove();
    },
    async resetFilterFields() {
      this.filterFields = {
        search: "",
        type: "",
        expiry_days: "",
        days: "",
        tags: [],
        doc_type: "",
        required: "True",
        division: [],
      };
      await this.getDocuments();
    },
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    async sendDocumentData() {
      try {
        if (
          this.documentData.description &&
          this.checkDescriptionLength(this.documentData.description)
        ) {
          throw {
            description: [this.$t("dashboardPage.descriptionMaxLength")],
          };
        }
        const nullKeys = this.checkNullValues({
          ...(this.allowUpdateOwnerOperatorDocs ? {} : { name: this.modelName }),
          date: this.documentData.date,
          document: this.documentData.document,
          ...(this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}),
        });
        if (nullKeys.length === 0) {
          this.setLoader(true);
          let formData = new FormData();
          let fileType =
            this.documentData.document instanceof File ||
            this.documentData.document instanceof Blob;
          if (!fileType) this.documentData.document = null;
          const modelType = this.allowUpdateOwnerOperatorDocs
            ? "teammember"
            : this.nameOptions.filter((item) => item.id === this.documentData.name)[0]
                .type;
          const ownerOperator = this.$store.state.user.user.team_member;
          formData.append(
            "object_id",
            this.allowUpdateOwnerOperatorDocs
              ? ownerOperator.id
              : this.modelName.split("-")[1]
          );
          formData.append("date", moment(this.documentData.date).format("YYYY-MM-DD"));
          formData.append("description", this.documentData.description);
          if (this.documentData.doc_type)
            formData.append("doc_type", this.documentData.doc_type);
          formData.append("type", this.documentData.type);
          formData.append(
            "expiry_date",
            this.documentData.expiry_date
              ? moment(this.documentData.expiry_date).format("YYYY-MM-DD")
              : ""
          );
          if (this.documentData.document)
            formData.append(
              "document",
              new File(
                [this.documentData.document],
                `${
                  this.allowUpdateOwnerOperatorDocs
                    ? ownerOperator.name
                    : this.nameOptions.filter((item) => item.id === this.modelName)[0]
                        .name
                }` +
                  "_" +
                  this.documentData.description +
                  "_" +
                  this.userCompany +
                  "_" +
                  new Date().getTime() +
                  "." +
                  this.documentData.document["type"].split("/").pop(),
                { type: this.documentData.document["type"] }
              )
            );
          formData.append("driver", this.documentData.driver);
          formData.append("dot_mode", this.documentData.dot_mode);
          formData.append("public", this.documentData.public);
          formData.append("model_type", modelType === "Tag Doc" ? "company" : modelType);
          if (
            !this.allowUpdateOwnerOperatorDocs &&
            this.nameOptions.filter((item) => item.id === this.documentData.name)[0]
              .type === "company"
          )
            formData.append("division", this.documentData.division);
          if (this.isTagDoc) {
            formData.append("unattached", true);
            formData.append("tagged_model", this.documentData.tagged_model);
            this.documentData.tags.forEach((tag) => {
              formData.append("tags", tag);
            });
          }
          if (this.addDocument) {
            await this.sendTeamMemberDocument(formData);
          } else {
            this.documentData = await this.updateTeamMemberDocument({
              id: this.documentData.id,
              payload: formData,
            });
          }
          await this.setNotification({
            msg: this.addDocument
              ? this.$t("dashboardPage.docAdded")
              : this.$t("dashboardPage.docUpdated"),
            type: "success",
            color: "green",
          });
          this.$bvModal.hide("modal-document");
          this.addDocument = false;
          this.nameOptions = [];
          await this.getDocuments();
          this.documentData = {
            object_id: null,
            date: null,
            name: null,
            type: null,
            document: null,
            description: null,
            expiry_date: "",
            driver: true,
            public: false,
            dot_mode: true,
            doc_type: "",
            division: null,
            tagged_model: "-",
            tags: [],
          };
          this.fileName = null;
          this.setLoader(false);
        } else {
          let error = {};
          nullKeys.forEach((x) => {
            error[x] = [this.$t("dashboardPage.fieldRequired")];
          });
          throw error;
        }
      } catch (error) {
        this.setLoader(false);
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
      }
    },
    async editDocument(id, name, type = null) {
      await this.getSingleDoc(id);
      const data = this.items.filter((item) => item.id === id)[0];
      let typeofDoc = data?.type ? data?.type : type;
      typeofDoc = typeofDoc.charAt(0).toUpperCase() + typeofDoc.slice(1);
      this.nameOptions = [
        {
          id: `${typeofDoc}-${
            typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
          }`,
          label: data?.name ? data?.name : name,
          type: `${
            typeofDoc === "Company"
              ? "company"
              : typeofDoc === "Vehicle" || typeofDoc === "Trailer"
              ? "equipment"
              : "teammember"
          }`,
          name: data?.name ? data?.name : name,
          model: typeofDoc === "Tag Doc" ? "Company" : typeofDoc,
        },
      ];
      this.nameOptions = [
        ...new Map(this.nameOptions.map((item) => [item["id"], item])).values(),
      ];
      this.showDivision = typeofDoc === "Company" ? true : false;
      this.showPublic = typeofDoc !== "Driver" ? true : false;
      this.modelType = typeofDoc === "Tag Doc" ? "Company" : typeofDoc;
      this.isTagDoc = typeofDoc === "Tag Doc";
      this.documentIndex = id;
      this.documentData = this.singleDoc;
      this.documentData = {
        ...this.singleDoc,
        doc_type: this.singleDoc.doc_type_info.id,
        date: moment.tz(this.singleDoc.date, this.userTimeZone).toDate(),
        expiry_date: this.singleDoc.expiry_date
          ? moment.tz(this.singleDoc.expiry_date, this.userTimeZone).toDate()
          : "",
      };
      this.documentData.type = typeofDoc;
      this.documentData.name = `${typeofDoc}-${
        typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
      }`;
      this.modelName = `${typeofDoc}-${
        typeofDoc === "Company" ? this.userCompany : this.singleDoc.document_of.id
      }`;
      this.documentData.docName = name;
      if (this.documentData.document) {
        let file_name = "";
        if (typeof this.documentData.document === "string") {
          file_name = this.documentData.document;
        } else {
          file_name = this.documentData.document.name;
        }
        this.fileName = file_name.split("/").pop().split("#")[0].split("?")[0];
      } else {
        this.documentData.document = null;
        this.fileName = "";
      }
      this.errors = {
        date: null,
        type: null,
        document: null,
        description: null,
        ...(this.company[0].doc_type ? { doc_type: null } : {}),
      };
      this.defaultData = JSON.parse(
        JSON.stringify({
          ...this.documentData,
          doc_type: this.singleDoc.doc_type_info.id
            ? this.singleDoc.doc_type_info.id
            : "",
        })
      );
      this.$bvModal.show("modal-document");
    },
    addRequiredDoc(data) {
      this.docData = data;
      this.docData.type = data?.type.charAt(0).toUpperCase() + data?.type.slice(1);
      this.$bvModal.show("modal-add-document");
    },
    async searchAssets(searchText) {
      if (searchText) {
        let options = [];
        let equipmentRecords;
        if (this.allowUpdateDocEquipment || this.allowUpdateOwnerOperatorDocs) {
          equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
        }
        if (
          this.allowUpdateDocDrivers &&
          (!this.allowUpdateDocEquipment ||
            (equipmentRecords && equipmentRecords.length === 0))
        ) {
          const driverRecords = await this.getFilteredDrivers(searchText);
          if (driverRecords?.length) {
            driverRecords.map((item) => {
              options.push({
                id: `Driver-${item.id}`,
                label: item.name,
                type: "teammember",
                name: `${item.name}_`,
                model: "Driver",
              });
            });
          }
        } else {
          if (equipmentRecords) {
            equipmentRecords.map((item) => {
              options.push({
                id: `${item.type}-${item.id}`,
                label: item.unit_no,
                type: "equipment",
                name: `${item.unit_no}_`,
                model: item.type,
              });
            });
          }
        }
        if (this.allowUpdateDocCompany || this.allowUpdateOwnerOperatorDocs) {
          if (this.allowUpdateDocCompany) {
            this.nameOptions = this.nameOptions.concat(options).concat([
              {
                id: `Company-${this.userCompany}`,
                label: "Company",
                type: "company",
                name: "Company",
                model: "Company",
              },
              {
                id: `CompanyTagDoc-${this.userCompany}`,
                label: "Tag Doc",
                type: "Tag Doc",
                name: "Company",
                model: "Company",
              },
            ]);
          }
          if (this.allowUpdateOwnerOperatorDocs) {
            const item = this.$store.state.user.user.team_member;
            this.nameOptions = this.nameOptions.concat(options).concat([
              {
                id: `Driver-${item.id}`,
                label: item.name,
                type: "teammember",
                name: `${item.name}_`,
                model: "Driver",
              },
            ]);
          }
        } else this.nameOptions = options;
        this.nameOptions = [
          ...new Map(this.nameOptions.map((item) => [item["id"], item])).values(),
        ];
      }
    },
    getNameItem(item) {
      this.modelType = item.model;
      this.showDivision = item.type === "company" ? true : false;
      this.showPublic = item.model !== "teammember" ? true : false;
      this.isTagDoc = item.type == "Tag Doc";
      this.documentData.doc_type = "";
      this.documentData.description = null;
      if (this.showDivision)
        this.documentData.division = this.divisions.filter(
          (division) => division.default
        )[0]?.id;
      if (this.isTagDoc) {
        this.documentData["tagged_model"] = "-";
        this.documentData["tags"] = [];
      }
    },
    removeFile() {
      this.fileName = null;
      this.documentData.document = null;
      this.media = null;
      this.mediaType = null;
    },
    async downloadExcel() {
      try {
        this.setLoader(true);
        let url = "";
        let tags = "";
        let data = null;
        if (this.documentType === "required_docs") {
          Object.keys(this.filterFields).map((key) => {
            if (
              (key === "tags" || key === "division" || key === "exclude_tags") &&
              this.filterFields[key].length > 0
            ) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            } else if (
              this.filterFields[key] !== "" &&
              key !== "tags" &&
              key !== "exclude_tags" &&
              key !== "division"
            ) {
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&`;
            }
          });
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=name&sort_order=asc&`;
          }
          url += "export_to_csv=True";
          data = await this.exportAllRequiredDocsData(url);
        } else if (this.documentType === "live_view") {
          console.log("123");
          Object.keys(this.filterFields).map((key) => {
            if (key === "tags" && this.filterFields[key].length > 0) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            }
          });
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=name&sort_order=asc&`;
          }
          url += `page=${this.currentPage}&page_size=${this.perPage}`;
          data = await this.exportLiveDocumentsData(url);
        } else {
          Object.keys(this.filterFields).map((key) => {
            if (
              (key === "tags" || key === "division" || key === "exclude_tags") &&
              this.filterFields[key].length > 0
            ) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            } else if (
              this.filterFields[key] !== "" &&
              key !== "tags" &&
              key !== "exclude_tags" &&
              key !== "division"
            ) {
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&`;
            }
          });
          if (this.documentType) url += `tab=${this.documentType}&`;
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=Days&sort_order=asc&`;
          }
          data = await this.exportExpiryData(url);
        }
        const blob = new Blob([data], { type: "text/csv" });
        const csvUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = csvUrl;
        a.download =
          this.documentType === "required_docs"
            ? "missing-docs.csv"
            : this.documentType === "live_view"
            ? "live-docs.csv"
            : "expiring-docs.csv";
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        await this.setNotification({
          msg: this.$t("dashboardPage.fileExported"),
          type: "success",
          color: "green",
        });
        this.setLoader(false);
        this.setLoader(false);
      } catch (e) {
        this.setLoader(false);
        console.log(e);
      }
    },
    async getDocuments() {
      try {
        this.isBusy = true;
        let url = "";
        let tags = "";
        let data = null;
        this.items = [];
        if (this.documentType === "required_docs") {
          Object.keys(this.filterFields).map((key) => {
            if (
              (key === "tags" || key === "division" || key === "exclude_tags") &&
              this.filterFields[key].length > 0
            ) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            } else if (
              this.filterFields[key] !== "" &&
              key !== "tags" &&
              key !== "exclude_tags" &&
              key !== "division"
            ) {
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&`;
            }
          });
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=name&sort_order=asc&`;
          }
          url += `page=${this.currentPage}&page_size=${this.perPage}`;
          data = await this.getAllRequiredDocs(url);
          if (data.total_entries) {
            this.rows = data.total_entries;
            this.requiredDocsCount = data.total_entries >= 0 ? data.total_entries : 0;
            const start =
              this.currentPage === 1 ? 1 : this.perPage * (this.currentPage - 1) + 1;
            const end = this.perPage * (this.currentPage - 1) + data.queryset_count;
            this.positionText = this.$t("dashboardPage.positionTextDash", {
              start,
              end,
              total: data.total_entries,
            });
          } else {
            this.rows = 0;
            this.positionText = this.$t("dashboardPage.emptyPosition");
          }
          data.records.map((item) => {
            const tableItem = {};
            Object.keys(item).map((key) => {
              if (key === "tags") {
                tableItem[key] = item[key].map((tag) => tag.add_tag);
              } else if (item[key]) tableItem[key] = item[key];
              else tableItem[key] = "-";
            });
            this.items.push(tableItem);
          });
        } else if (this.documentType === "live_view") {
          Object.keys(this.filterFields).map((key) => {
            if (key === "tags" && this.filterFields[key].length > 0) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            }
          });
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=name&sort_order=asc&`;
          }
          url += `page=${this.currentPage}&page_size=${this.perPage}`;
          data = await this.getAllLiveDocuments(url);
          this.liveViewCount =
            data.total_entries_count >= 0 ? data.total_entries_count : 0;
          data.data.forEach((item) => {
            let color;
            if (item.documents.length === 0) {
              color = "background:#C4C4C4";
            } else if (
              item.documents.filter(
                (doc) =>
                  doc.expiry_date &&
                  parseInt(
                    (new Date(doc.expiry_date) - new Date()) / (1000 * 60 * 60 * 24),
                    10
                  ) <= 0
              ).length
            ) {
              color = "background:#FF0000";
            } else if (
              item.documents.filter(
                (doc) =>
                  doc.expiry_date &&
                  parseInt(
                    (new Date(doc.expiry_date) - new Date()) / (1000 * 60 * 60 * 24),
                    10
                  ) <= 31 &&
                  parseInt(
                    (new Date(doc.expiry_date) - new Date()) / (1000 * 60 * 60 * 24),
                    10
                  ) >= 1
              ).length
            ) {
              color = "background:#FFC800";
            } else if (item.documents.filter((doc) => doc.is_missing).length) {
              color = "background:#C4C4C4";
            } else {
              color = "background:#2CCE89";
            }
            this.items.push({
              name: item.name ? item.name : "-",
              vehicle: item.vehicle ? item.vehicle : "-",
              trailer: item.trailer ? item.trailer : "-",
              documents: item.documents,
              location: item.location ? item.location : "-",
              driving: item.driving,
              status: "",
              num_docs: item.documents.length,
              color,
              _showDetails: false,
            });
          });
          if (data.total_entries_count) {
            this.rows = data.total_entries_count;
            const start =
              this.currentPage === 1 ? 1 : this.perPage * (this.currentPage - 1) + 1;
            const end = Math.min(
              this.perPage * this.currentPage,
              data.total_entries_count
            );
            this.positionText = this.$t("dashboardPage.positionText", {
              start,
              end,
              total: data.total_entries_count,
            });
          } else {
            this.rows = 0;
            this.positionText = this.$t("dashboardPage.emptyPosition");
          }
        } else {
          Object.keys(this.filterFields).map((key) => {
            if (
              (key === "tags" || key === "division" || key === "exclude_tags") &&
              this.filterFields[key].length > 0
            ) {
              this.filterFields[key].map((item, index) =>
                index === 0 ? (tags = item) : (tags += "," + item)
              );
              url += `${key}=${encodeURIComponent(tags)}&`;
            } else if (
              this.filterFields[key] !== "" &&
              key !== "tags" &&
              key !== "exclude_tags" &&
              key !== "division"
            ) {
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&`;
            }
          });
          if (this.documentType) url += `tab=${this.documentType}&`;
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${
              this.sortDesc ? "desc" : "asc"
            }&`;
          } else {
            url += `sort_field=Days&sort_order=asc&`;
          }
          url += `page=${this.currentPage}&page_size=${this.perPage}`;
          data = await this.getAllDocuments(url);
          this.regularCount = data.regular_count >= 0 ? data.regular_count : 0;
          this.snoozedCount = data.snoozed_count >= 0 ? data.snoozed_count : 0;
          this.noNotifyCount = data.no_notify_count >= 0 ? data.no_notify_count : 0;
          this.liveViewCount = data.live_view >= 0 ? data.live_view : 0;
          this.requiredDocsCount =
            data.required_docs_count >= 0 ? data.required_docs_count : 0;
          if (data.count) {
            this.rows = data.count;
            const start =
              this.currentPage === 1 ? 1 : this.perPage * (this.currentPage - 1) + 1;
            const end = Math.min(this.perPage * this.currentPage, data.count);
            this.positionText = this.$t("dashboardPage.positionText", {
              start,
              end,
              total: data.count,
            });
          } else {
            this.rows = 0;
            this.positionText = this.$t("dashboardPage.emptyPosition");
          }
          this.items = [];
          this.documents.forEach((doc) => {
            if (doc.Days <= 60) {
              if (doc.Days <= 0) {
                var color = "color:red";
              } else if (doc.Days <= 31 && doc.Days >= 1) {
                color = "color:orange";
              } else {
                color = "color:green";
              }
              this.items.push({
                name: doc.name,
                id: doc.id,
                type: doc.type,
                description: doc.description,
                Date: `<span style=${color}>${moment(doc.Date).format("ll")}</span>`,
                "Expiry Date": moment(doc.Date).format("ll"),
                color: color,
                Days: doc.Days,
                route: doc.team_id ? "driver" : doc.company_id ? "company" : "equipment",
                tags: doc.tags,
                driver: doc.driver,
                dot_mode: doc.dot_mode,
                public: doc.public,
                note: doc.note,
                object_id: doc.object_id,
                is_snoozed: doc.is_snoozed,
              });
            }
          });
        }
        if (this.items.length === 0) this.emptyTable = true;
        else this.emptyTable = false;
        this.isBusy = false;
        this.isTableMounted = true;
        this.$nextTick(this.measureColumns);
      } catch (e) {
        this.isBusy = false;
        console.log(e);
      }
    },
    phoneRule: (value) => {
      const pattern = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
      return pattern.test(value);
    },
    handleFileUpload() {
      this.documentData.document = this.$refs.docFile.files[0];
      this.fileName = this.documentData.document.name;
      this.media = URL.createObjectURL(this.documentData.document);
      if (this.$refs.docFile.files[0].type.includes("pdf")) this.mediaType = "pdf";
      else this.mediaType = "image";
    },
  },
  watch: {
    perPage: {
      async handler() {
        await this.getDocuments();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getDocuments();
      },
    },
    sortBy: {
      async handler() {
        await this.getDocuments();
      },
    },
    sortDesc: {
      async handler() {
        await this.getDocuments();
      },
    },
    filterFields: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    // documentData:{
    //   handler(){
    //     this.modelName = this.documentData.name
    //   },
    //   deep:true
    // }
    company: {
      async handler() {
        await this.getAllTags(this.userCompany);
        this.tags.map((item) => {
          this.allTags.push({
            id: item.add_tag,
            label: item.add_tag,
          });
          this.docTags.push({
            id: item.id,
            label: item.add_tag,
          });
        });
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measureColumns);
  },
  async mounted() {
    window.addEventListener("resize", this.measureColumns);
    try {
      const data = await this.getDashboardStats();
      this.dashboardSummary = data;
      this.summaryLoading = false;
      await this.getDocuments();
    } catch (error) {
      this.summaryLoading = false;
      console.log(error);
    }
  },
  data() {
    return {
      checkValueExists,
      checkDescriptionLength,
      fileName: "",
      showDocumentModal: false,
      showArchiveDocumentModal: false,
      showSnoozeDocumentModal: false,
      emptyTable: false,
      positionText: "",
      rows: 0,
      media: null,
      mediaType: null,
      mediaID: null,
      docName: "",
      savedScroll: { page: 0, table: 0 },
      columnWidths: [],
      allTags: [],
      docTags: [],
      documentType: "",
      isTagDoc: false,
      isTableMounted: false,
      summaryLoading: true,
      panzoom: null,
      sortBy: undefined,
      regularCount: 0,
      docData: null,
      snoozedCount: 0,
      showPublic: false,
      noNotifyCount: 0,
      requiredDocsCount: 0,
      liveViewCount: 0,
      docTypeOptions: [],
      notesData: null,
      sortDesc: undefined,
      filterFields: {
        search: "",
        type: "",
        expiry_days: "",
        days: "",
        tags: [],
        doc_type: "",
        required: "True",
        division: [],
      },
      searchGroups: null,
      docId: null,
      dashboardSummary: {
        total_drivers: 0,
        active_drivers: 0,
        inactive_drivers: 0,
        total_vehicles: 0,
        total_trailers: 0,
        assigned_vehicles: 0,
        unassigned_vehicles: 0,
        assigned_trailers: 0,
        unassigned_trailers: 0,
        total_documents: 0,
        archived_documents: 0,
        unarchived_documents: 0,
        expired_documents_count: 0,
        expired_documents_percentage: 0,
        expiring_soon_count: 0,
        expiring_soon_documents_percentage: 0,
        review_count: 0,
        file_drop_count: 0,
      },
      documentData: {
        name: null,
        object_id: null,
        date: new Date(),
        type: null,
        document: null,
        description: null,
        expiry_date: "",
        driver: true,
        public: false,
        doc_type: "",
        tagged_model: "-",
        tags: [],
      },
      errors: {
        date: null,
        name: null,
        document: null,
        description: null,
      },
      addDocument: false,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format("ll") : "";
        },
        parse: (value) => {
          if (!value) return null;
          const formats = [
            "ll",
            "LL",
            "MMM D, YYYY",
            "MMMM D, YYYY",
            "M/D/YYYY",
            "MM/DD/YYYY",
            "M-D-YYYY",
            "MM-DD-YYYY",
            "YYYY-MM-DD",
            "YYYY/MM/DD",
            "D MMM YYYY",
            "D MMMM YYYY",
            "D/M/YYYY",
            "DD/MM/YYYY",
          ];
          const m = moment(value, formats, true);
          if (m.isValid()) return m.toDate();
          const lenient = moment(value);
          return lenient.isValid() ? lenient.toDate() : null;
        },
      },
      perPage: 10,
      currentPage: 1,
      nameOptions: [],
      items: [],
      defaultData: {},
      passwords: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
      roleOptions: [
        {
          value: "Admin",
          text: "Admin",
        },
        {
          value: "Operations",
          text: "Operations",
        },
        {
          value: "Maintenance",
          text: "Maintenance",
        },
        {
          value: "Driver",
          text: "Driver",
        },
      ],

      showDivision: false,
      modelType: null,
      fields: [
        {
          key: "Name",
        },
        {
          key: "Type",
        },
        {
          key: "Inspection",
        },
        {
          key: "Days",
        },
      ],
      modelName: null,
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");

/* v-select dropdowns appended to <body> must clear the modal (z-index 1050) */
body > .vs__dropdown-menu {
  z-index: 1100;
}

/* the tooltip wrapper must not become a block box inside the cell */
.live-view-table .v-application.d-contents,
.live-view-table .v-application.d-contents .v-application--wrap {
  display: contents;
}

/* being inside the cell, the tooltip would inherit its narrow width and
   word-breaking, which stacks the text one character per line */
.live-view-table .v-tooltip__content {
  width: max-content;
  max-width: 320px;
  white-space: normal;
  word-break: normal;
  text-align: left;
}

.lv-ellipsis {
  display: inline-block;
}

.lv-missing-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 99px;
  background: #fde8e8;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 600;
}

.lv-expand-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #e2e6f0;
  background: #fff;
  color: #2d69f6;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.lv-expand-btn:hover {
  background: #eff6ff;
  border-color: #2d69f6;
}

/* fixed layout keeps the expanded document rows aligned with the parent columns */
/* auto layout so columns share the container by content weight; the table stays
   within the viewport and long values wrap instead of stretching it */
.live-view-table {
  table-layout: auto;
  width: 100%;
}

.live-view-table td {
  white-space: normal !important;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
}

.live-view-table th {
  white-space: nowrap;
}

/* the details cell must not inset the nested table, or every column shifts */
.live-view-table > tbody > tr.b-table-details > td {
  padding: 0 !important;
  background-color: #fafafa;
}

.live-view-details,
.live-view-details > tbody > tr,
.live-view-details td {
  background-color: #fafafa !important;
  border-top: none !important;
}

/* the child mirrors the parent's measured columns, so its layout must be fixed
   for those widths to be honoured exactly */
.live-view-details {
  table-layout: fixed;
  width: 100%;
}

/* a long document value wraps inside its own cell instead of widening the column */
.live-view-details td {
  white-space: normal !important;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
}

/* the group's last document row butts up against the next parent row */
.live-view-details > tbody > tr:last-child > td {
  border-bottom: none !important;
}

.userImage {
  /* max-width: 150px; */
  width: 150px;
  height: 150px;
  /* max-height: 140px; */
  object-fit: cover;
  margin: 3px;
  border: 3px solid lightgrey;
}

a {
  text-decoration: none !important;
  color: var(--black) !important;
}

.userFields {
  padding: 0 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.userFields label {
  margin-right: auto;
}

.dashboard_total .total_team {
  display: flex;
  align-items: center;
  padding: 25px;
  background-color: white;
  border-radius: 0.25rem;
  height: 104px;
  box-shadow: 0 4px 50px rgb(0 0 0/10%);
  border: 1px solid #dee2e6;
}

.dashboard_total .total_team img {
  margin-right: 20px;
}

/* only the totals row carries an extra line under its label, so just those cards
   are top-aligned to keep their numbers on one line; the icon stays centred */
.dashboard_total .total_team--top {
  align-items: flex-start;
  padding: 18px 20px;
}

.dashboard_total .total_team--top > img {
  align-self: center;
}

.dashboard_total .total_team .number {
  font-size: 23px !important;
  font-weight: 700 !important;
  color: black;
  text-align: left;
  margin-bottom: 0px !important;
}

.dashboard_total .total_team .assignment-split {
  font-size: 11px !important;
  color: #6b6960;
  margin-top: 2px;
  white-space: nowrap;
}

.dashboard_total .total_team p {
  font-size: 14px;
  color: black;
  margin-bottom: 0;
  text-align: left;
}

.table_heading {
  background-color: #2d69f6;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.table_heading .heading {
  color: #fff;
}

.main-container .table.bg-white {
  box-shadow: 0px 4px 50px rgb(0 0 0 / 10%);
}

.table {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow: hidden;
}

.table > :not(caption) > * > * {
  padding: 10px 15px;
}

.table_heading .view {
  background-color: var(--btn-bg-color);
  font-size: 14px;
  color: #fff !important;
  border: none;
}

.table_heading .view,
.table_heading .view:focus,
.table_heading .view:active,
.table_heading .view:hover {
  background-color: var(--btn-bg-color) !important;
  box-shadow: none;
}

.card {
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 20px;
}

.profile-card {
  box-shadow: 0px 4px 50px rgb(0 0 0 / 10%) !important;
}

.save {
  background-color: var(--btn-bg-color) !important;
}

.card-detail .email {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 30px;
  position: relative;
  flex-direction: row;
  margin-bottom: 5px;
}

.card-detail .email.update-change {
  display: block;
  padding: 0;
  margin-bottom: 13px;
  position: relative;
}

.card-detail .email.update-change svg {
  position: absolute;
  right: 10px;
  top: 43px;
}

/* BEFORE CLICK THE UPDATE CSS */
.card-detail .email .heading {
  font-weight: 600;
  width: 85px;
  text-align: left;
}

.card-detail .email p {
  line-break: anywhere;
  line-height: 16px;
}

/* AFTER CLICK THE UPDATE CSS */
.card-detail .email.update-change .heading {
  width: auto;
}

.card-detail .email p {
  margin-bottom: 0;
}

.card-detail .change {
  background-color: #2d69f6;
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 12px;
  position: absolute;
  right: -10px;
  bottom: -45px;
}

.card-detail .change:hover,
.card-detail .change:focus,
.card-detail .change:active {
  background-color: #2d69f6;
}

.card-detail .w-100 {
  width: 100% !important;
  margin: auto;
  flex-direction: column;
}

.table-dashboard .table {
  margin-bottom: 0rem !important;
}

.designation {
  color: var(--black);
  opacity: 0.6;
}

.d-contents .v-application--wrap {
  display: contents;
  align-items: center;
}

@media (max-width: 1200px) {
  .card-detail .change {
    right: -25px;
    padding: 2px 5px;
  }
}

@media (max-width: 1140px) {
  .dashboard_total .total_team {
    padding: 9px;
  }
}

@media (min-width: 991px) and (max-width: 1200px) {
  .card-detail .change {
    right: -10px;
  }
}

@media (max-width: 991px) {
  .table {
    overflow-x: scroll;
  }

  .card-detail .change {
    right: 0px;
  }
}

@media (max-width: 575px) {
  .card-detail .change {
    right: 0;
  }

  .card-detail .email p {
    font-size: 11px;
  }
  .dashboard_total .total_team{
    align-items: center;
  }
}

@media (max-width: 395px) {
  .table_heading {
    padding: 12px !important;
  }

  .table_heading .view {
    font-size: 12px;
  }

  .card-detail .email p {
    overflow: hidden;
    line-height: 18px;
  }
}
</style>
